<template>
  <q-page class="container" padding>
    <PageHeader
      title="Relatório de Cautela"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <q-card-section>
      <q-form ref="myForm">
        <div
          class="row col-12 q-col-gutter-sm text-brand-5 text-weight-bold q-mt-sm"
        >
          <div
            class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
          >
            Unidade
            <lista-unidades-select v-model="unidade"></lista-unidades-select>
          </div>
          <div>
            Nome do Colaborador
            <SelectFuncionario @emitirFuncionario="receberDadosFuncionario" />
          </div>
          <div
            class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
          >
            Data Inicial
            <q-input
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtros.dataInicial"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="filtros.dataInicial"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div
            class="col-lg-2 col-md-2 col-sm-12 col-xs-12 text-brand-5 text-weight-bold"
          >
            Data Final
            <q-input
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="filtros.dataFinal"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="filtros.dataFinal"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-2">
            <p></p>
            <q-btn
              class="q-mt-sm q-ml-sm full-width"
              color="primary"
              no-caps
              icon="filter_alt"
              label="Filtrar"
              type="submit"
              @click.prevent="filtrar()"
            />
          </div>
        </div>
      </q-form>
    </q-card-section>

    <div class="q-ml-md q-mt-lg q-mb-md">
      <upload-cautela
        :titulo="'Enviar cautela assinada'"
        :transaction_uuid="filtros.funcionario"
        :template="'cautela'"
      />
    </div>

    <div class="col-12 q-ml-md q-mt-lg">
      <div class="tet-h6 text-brand-5 text-weight-bold">
        Ficha de Responsabilidade
      </div>
      <span class="row">
        <div class="col-2">
          <q-btn
            class="q-mt-lg"
            color="primary"
            no-caps
            icon="print"
            label="Imprimir"
            type="submit"
            @click.prevent="imprimir"
          />
        </div>
        <div class="col-2">
          <q-btn
            class="q-mt-lg"
            color="secondary"
            no-caps
            label="Documentos"
            @click="getDocumentos"
          />
        </div>
      </span>
    </div>

    <q-dialog v-model="documentos">
      <q-card style="width: 800px; max-width: 80vw; height: 80%">
        <q-card-section class="row justify-between">
          <div class="text-h6">Documentos Enviados</div>
          <div>
            Data Inicial:
            <q-input
              dense
              outlined
              placeholder="DD/MM/AAAA"
              v-model="data"
              mask="##/##/####"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date :locale="myLocale" mask="DD/MM/YYYY" v-model="data">
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </q-card-section>
        <q-separator />
        <ul class="col-12">
          <li
            class="text-brand-5"
            v-for="documento in listaDocumentos"
            :key="documento.descricao"
          >
            <div class="row justify-between q-mb-md q-ml-sm items-center">
              <div>
                <p class="text-subtitle1 text-weight-bolder text-brand-5">
                  Documento
                </p>
                <div>Observação: {{ documento.observacao }}</div>
                <div>
                  Data de Criação:
                  {{
                    documento.data_upload
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </div>
              </div>
              <div class="q-gutter-x-sm q-mt-xl">
                <a :href="documento.url" download style="text-decoration: none">
                  <q-btn
                    dense
                    no-caps
                    label="Baixar Documento"
                    icon="file_download"
                    color="positive"
                  ></q-btn>
                </a>
                <q-btn
                  dense
                  no-caps
                  flat
                  label="Excluir Documento"
                  icon="delete"
                  color="negative"
                  @click="deletarDocumento(documento.uuid)"
                ></q-btn>
              </div>
            </div>
          </li>
        </ul>
      </q-card>
    </q-dialog>

    <div class="q-pa-md q-mt-lg">
      <main class="base">
        <header class="row headerBase">
          <img
            v-if="
              $store.state.autenticacao.logo &&
              $store.state.autenticacao.logo.logoImpressao
            "
            :src="$store.state.autenticacao.logo.logoImpressao"
            alt="Multpex Logo"
            class="multpex q-pl-sm"
          />

          <img
            v-else
            src="../../../assets/MULTPEX_VETOR.png"
            alt="Multpex Logo"
            class="multpex q-pl-sm"
          />
          <p class="text-h6 text-bold q-pa-md" style="word-wrap: break-word">
            {{ dadosFicha.titulo ? dadosFicha.titulo : "Título" }}
          </p>
        </header>
        <section class="separador"></section>
        <div class="data1">
          <p class="q-pl-sm text-bold">NOME: {{ nome }}</p>
        </div>
        <div class="row data2">
          <p class="q-pl-sm função text-bold">FUNÇÃO: {{ funcao }}</p>
          <p class="q-pl-sm registro text-bold">REGISTRO: {{ registro }}</p>
        </div>
        <section class="separador"></section>
        <div>
          <p class="row justify-center text-bold" style="word-wrap: break-word">
            {{ dadosFicha.subtitulo ? dadosFicha.subtitulo : "Subtítulo" }}
          </p>
        </div>
        <div class="data2 text-bold q-pl-sm" style="word-wrap: break-word">
          <p>
            {{ dadosFicha.dizeres ? dadosFicha.dizeres : "Dizeres" }}
          </p>
        </div>
        <div class="row data2 border-botom">
          <div class="column DESCRIÇÃODOMATERIAL borderleft">
            <p class="q-pa-md row justify-center text-bold">
              DESCRIÇÃO DO MATERIAL
            </p>
          </div>
          <div class="column ENTREGA borderleft">
            <p class="row justify-center border-botom text-bold">ENTREGA</p>
            <div class="row">
              <div class="table1 borderleft">
                <p class="text text-bold">Nº DO PATRIMONIO</p>
              </div>

              <div class="table3 borderleft">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="table4">
                <p class="text text-bold">DATA</p>
              </div>
            </div>
          </div>
          <div class="column DEVOLUÇÃO">
            <p class="row justify-center border-botom text-bold">DEVOLUÇÃO</p>
            <div style="height: 65%" class="row">
              <div class="secondTable2 borderleft">
                <p class="text text-bold">ASSINATURA</p>
              </div>
              <div class="secondTable3 column">
                <p class="text text-bold">DATA</p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="data3 row border-botom"
          v-for="(tabela, index) in tabelas"
          :key="index"
        >
          <div class="DESCRIÇÃODOMATERIAL borderleft">
            <p style="width: 100%" class="row justify-center">
              {{ tabela.ferramenta_descricao }}
            </p>
          </div>
          <div class="ENTREGA borderleft">
            <div class="row" style="height: 100%">
              <div class="table1 borderleft column">
                <p
                  v-if="tabela.ferramenta_patrimonio != null"
                  style="width: 100%"
                  class="text"
                >
                  {{ tabela.ferramenta_patrimonio.toLowerCase() }}
                </p>
                <p v-else style="width: 100%" class="text">Sem Nº</p>
              </div>

              <div class="table3 borderleft column">
                <q-img
                  v-if="
                    tabela.retirada_biometria != null &&
                    tabela.retirada_biometria != ''
                  "
                  height="90px"
                  width="90px"
                  class="biometria"
                  alt=""
                  fit="contain"
                  :src="tabela.retirada_biometria"
                />

                <p v-else style="width: 100%" class="text"></p>
              </div>
              <div class="table4 column">
                <p
                  v-if="
                    tabela.movimento_data_retirada != null &&
                    tabela.movimento_data_retirada != ''
                  "
                  style="width: 100%"
                  class="text"
                >
                  {{
                    tabela.movimento_data_retirada
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </p>
                <p v-else style="width: 100%" class="text">Sem data</p>
              </div>
            </div>
          </div>
          <div class="DEVOLUÇÃO">
            <div style="height: 100%" class="row">
              <div class="secondTable2 borderleft column">
                <q-img
                  v-if="
                    tabela.entrega_biometria != null &&
                    tabela.entrega_biometria != ''
                  "
                  height="90px"
                  width="90px"
                  class="biometria"
                  :src="tabela.entrega_biometria"
                  alt=""
                  fit="contain"
                />

                <p v-else style="width: 100%" class="text"></p>
              </div>
              <div class="secondTable3 column">
                <p
                  v-if="
                    tabela.movimento_data_devolucao != null &&
                    tabela.movimento_data_devolucao != ''
                  "
                  style="width: 100%"
                  class="text"
                >
                  {{
                    tabela.movimento_data_devolucao
                      .split(" ")[0]
                      .split("-")
                      .reverse()
                      .join("/")
                  }}
                </p>
                <p v-else style="width: 100%" class="text">Sem data</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </q-page>
</template>

<script>
import { ref, onMounted, inject, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import SelectFuncionario from "../components/SelectFuncionario.vue";

import UploadCautela from "../components/UploadCautela.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  name: "RelatórioMovimentacao",
  components: {
    SelectFuncionario,
    UploadCautela,
    ListaUnidadesSelect,
    PageHeader,
  },

  setup() {
    const store = useStore();
    const $q = useQuasar();
    const router = useRouter();
    const filtros = ref({
      unidade: "",
      funcionario: "",
      checklist: "",
      dataInicial: "",
      dataFinal: "",
    });
    const data = ref("");
    const documentos = ref(false);
    const listaDocumentos = ref([]);
    const tabelas = ref([]);
    const unidade = ref();
    const nome = ref("");
    const funcao = ref("");
    const registro = ref("");
    const keycloak = inject("keycloak");
    const realm = ref("");
    const dadosFicha = ref({
      titulo: "",
      subtitulo: "",
      dizeres: "",
    });

    const checklist = ref(["TODOS", "SOMENTE NÃO", "SOMENTE SIM"]);

    let filtrar = async () => {
      tabelas.value = [];
      if (filtros.value.funcionario === "") {
        $q.notify({
          message: "Selecione o funcionario.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        let dataInicial = filtros.value.dataInicial
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/");

        let dataFinal = filtros.value.dataFinal
          .split(" ")[0]
          .split("-")
          .reverse()
          .join("/");

        let resposta = await store.dispatch("fer/relatorioCautela", {
          unidadeId: "",
          funcionarioId: filtros.value.funcionario,
          dataInicial: dataInicial,
          dataFinal: dataFinal,
        });
        if (resposta.data.result.data.length == 0) {
          $q.notify({
            message: "Não houve retirada no periodo informado.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          return;
        }

        nome.value = "";
        funcao.value = "";
        registro.value = "";

        tabelas.value = resposta.data.result.data;
        nome.value = resposta.data.result.data[0].usuario_nome;
        funcao.value = resposta.data.result.data[0].usuario_ghe;
        registro.value = resposta.data.result.data[0].usuario_matricula;
      } catch (error) {
        console.log(error);
      }
    };

    let exportar = async () => {
      let dataInicial = filtros.value.dataInicial
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      let dataFinal = filtros.value.dataFinal
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      await store.dispatch("fer/exportarRelatorioCautela", {
        unidadeId: filtros.value.unidade,
        funcionarioId: filtros.value.funcionario,
        dataInicial: dataInicial,
        dataFinal: dataFinal,
      });
      mensagem(
        "Seu relatório de Cautela está sendo processado, você receberá um link pra download no seu email assim que ele estiver pronto!"
      );
    };

    let receberDadosFuncionario = async (value) => {
      filtros.value.funcionario = value.value.id;
    };

    const formataDataHora = (dataHora) => {
      const data = dataHora.split(" ")[0].split("-").reverse().join("/");

      const hora = dataHora.split(" ")[1].replace(" ", "");

      return `${data} ${hora}`;
    };

    let mensagem = (mensagem) => {
      $q.notify({
        message: mensagem,
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const imprimir = async () => {
      let nome = JSON.stringify(tabelas.value);
      if (nome == "[]") {
        $q.notify({
          message: "Filtre alguem antes de imprimir",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      router.push({ name: "imprimir", params: { nome } });
    };

    const getHeader = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      realm.value = keycloak.realm;
    };

    const getDocumentos = async () => {
      if (!filtros.value.funcionario) {
        $q.notify({
          message: "Filtre um funcionario antes",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      documentos.value = true;
      try {
        let response = await store.dispatch("fer/documentoCautela", {
          id: filtros.value.funcionario,
          data_inicial: data.value,
        });

        listaDocumentos.value = response.data.result.data;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao encontrar documentos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletarDocumento = async (value) => {
      try {
        await store.dispatch("fer/excluirDocumentoCautela", {
          id: value,
        });

        getDocumentos();
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro ao excluir documentos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const receberDadosFichaCautela = async () => {
      dadosFicha.value = {
        titulo: "",
        subtitulo: "",
        dizeres: "",
      };
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("fer/receberDadosFichaCautela", {
          vendor_id: store.state.org.unidadeData.id,
        });
        if (response.data.result.data.length > 0) {
          dadosFicha.value = {
            titulo: response.data.result.data[0].titulo,
            subtitulo: response.data.result.data[0].subtitulo,
            dizeres: response.data.result.data[0].dizeres,
          };
        }
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => data.value,
      () => {
        getDocumentos();
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        receberDadosFichaCautela();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    onMounted(() => {
      getHeader();
      receberDadosFichaCautela();
    });

    return {
      filter: ref(""),
      filtros,
      nome,
      getDocumentos,
      funcao,
      registro,
      receberDadosFuncionario,
      filtrar,
      checklist,
      formataDataHora,
      exportar,
      tabelas,
      imprimir,
      realm,
      documentos,
      listaDocumentos,
      deletarDocumento,
      data,
      unidade,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      receberDadosFichaCautela,
      dadosFicha,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.base {
  border: 1px solid black;
}

.base p {
  margin: 0px;
}

.headerBase {
  border-bottom: 1px solid black;
  display: flex;
  align-items: center;
}

.border-botom {
  border-bottom: 1px solid black;
}

.separador {
  height: 5px;
  background-color: rgba(128, 128, 128, 0.541);
  border-bottom: 1px solid black;
}

.função {
  width: 65%;
}

.registro {
  width: 30%;
}

.data2 {
  border-top: 1px solid black;
}

.DESCRIÇÃODOMATERIAL {
  width: 35%;
}

.DESCRIÇÃODOMATERIAL p {
  height: 100%;
  align-items: center;
}

.ENTREGA {
  width: 35%;
}

.DEVOLUÇÃO {
  width: 30%;
}

.borderleft {
  border-right: 1px solid black;
}

.text {
  text-align: center;
}

.table1 {
  display: flex;
  justify-content: center;
  width: 30%;
  align-items: center;
}

.table3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
}

.data3 {
  height: 96px !important;
}
.table4 {
  display: flex;
  justify-content: center;
  width: 35%;
  align-items: center;
}

.secondTable1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
}

.secondTable2 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
}

.secondTable3 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
  margin: 0 auto;
}

.border-top {
  border-top: 1px solid black;
}

.headerBase p {
  width: 79%;
  display: flex;
  justify-content: center;
}

.multpex {
  height: 50px;
  width: 130px;
}
</style>
